import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import GAListener from "@/components/GAListener";
import Home from "@/pages/Home";
import BookingWizard from "@/pages/BookingWizard";
import BookingSuccess from "@/pages/BookingSuccess";
import Services from "@/pages/Services";
import Areas from "@/pages/Areas";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import ProbateClearances from "@/pages/ProbateClearances";
import Reviews from "@/pages/Reviews";
import Gallery from "@/pages/Gallery";
import Team from "@/pages/Team";
import AreaPage from "@/pages/AreaPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <GAListener />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/probate" element={<ProbateClearances />} />
          <Route path="/areas" element={<Areas />} />
          <Route path="/areas/:slug" element={<AreaPage />} />
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/about" element={<About />} />
          <Route path="/team" element={<Team />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/book" element={<BookingWizard />} />
          <Route path="/booking/success" element={<BookingSuccess />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-center" />
    </div>
  );
}

export default App;
